import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import TripPlacesPage from './trip-places'

const tripPlaceRoutes: Route[] = [
  {
    path: Paths.SETTING_TRIP_PLACES,
    element: <TripPlacesPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripPlaceRoutes
